<!--
  --
  -- 予約履歴 ページ
  --
  -->
<template>
  <c-container form wide>
    <h1 class="text-h6">予約履歴</h1>

    <p class="text-body-2 text--secondary my-4">ご予約中から過去3ヶ月までのご予約履歴です。</p>

    <template v-if="items.length === 0">
      <c-no-item-card/>
    </template>

    <template v-else>
      <c-pager :page="page" :hasPrev="hasPrev" :hasNext="hasNext"/>

      <v-row dense>
        <v-col
          v-for="item in items"
          :key="item.reserveID"
          cols="12" sm="6"
        >
          <c-book-card :book="item"/>
        </v-col>
      </v-row>

      <c-pager :page="page" :hasPrev="hasPrev" :hasNext="hasNext"/>
    </template>

    <div class="d-flex flex-row flex-grow-1 mt-4">
      <!-- v-spacer />
      <v-btn
        color="primary"
        :to="{ name: 'book/new' }"
      >
        新しい予約を入れる
      </v-btn -->
      <v-btn text outlined to="#back" class="ml-2">戻る</v-btn>
    </div>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CNoItemCard from './CNoItemCard'
import CBookCard from './CBookCard'
import CPager from './CPager'

import * as api from '@/api'
import * as time from '@/libs/time'
import * as C from '@/consts'

export default {
  name: 'Books',
  mixins: [
    page('予約履歴')
  ],
  components: {
    CNoItemCard,
    CBookCard,
    CPager
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']

    // ページを取得する
    const page = (to.query.p || '1') - 0
    const offset = (page - 1) * C.BOOK_ITEMS
    const limit = C.BOOK_ITEMS

    // 表示する日付の範囲
    // const today = time.today()
    const today = time.create('2021-05-12')
    const past = time.clone(today)
    past.setMonth(past.getMonth() - C.BOOK_PAST)

    // 日付を書式化する
    const begin = time.format('Y-m-d', past)
    const end = time.format('Y-m-d', today)

    // ユーザの予約一覧を取得する
    const resp = await api.getUserReserves(userID, begin, end, offset, limit)
    return {
      ...resp.data,
      page
    }
  },

  props: {
    page: Number,
    hasPrev: Boolean,
    hasNext: Boolean,
    items: Array
  }
}
</script>
